<template>
	<div>
		<vxe-grid v-if="list_gridOptions" v-bind="list_gridOptions" @toolbar-button-click="list_toolbarButtonClickEvent"
			ref="groupkpiTable"></vxe-grid>
		<add-index :nodeid="nodeid" ref="addgroupkpiIndex" @modalhide="addHide" />
	</div>
</template>
<style scoped>

</style>
<script>
	import listMixins from '@_system/components/base/mixins/list/list.js'
	import addIndex from './add/index.vue'
	export default {
		mixins: [listMixins],
		props: {
			nodeid: {
				default: () => {
					return 0
				}
			}
		},
		data() {
			return {

			}
		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},
		created() {

		},
		mounted() {

		},
		methods: {
			list_beforeCreateGrid(gridOptions) {
				gridOptions.height = 450
				gridOptions.columns = [{
						field: 'kpi',
						title: '目标',
					},
					{
						field: 'date',
						title: '时间'
					},
					{
						field: '',
						title: '操作',
						width: 65,
						fixed: "right",
						align: 'center',
						slots: {
							default:({row})=>{
								return	[
										<el-button size="mini" type="text" style="color:#F56C6C;" onClick={()=>{this.deletegroupkpi(row)}}>删除</el-button>,										
									]
							}
						}
					},
				]
				gridOptions.toolbarConfig.buttons = [{
					name: '添加',
					status: 'primary',
					code: 'add'
				}]
				gridOptions.formConfig = false
			},
			add() {
				this.$refs.addgroupkpiIndex.modal_show()
			},
			addHide() {
				this.$refs.groupkpiTable.commitProxy('query')
			},
			deletegroupkpi(row){
				this.$api.BIshopgoods.deletegroupkpi({
					id: row.id,
				}).then(() => {
					this.$refs.groupkpiTable.commitProxy('query')
				})
			},
			list() {
				return new Promise((resolve) => {
					this.$api.BIshopgoods.listgroupkpi({
						nodeid: this.nodeid,
						type:'group'
					}).then((res) => {
						resolve({
							list: res
						})
					})
				})
			},
			submit() {
				//this.init()
			},
			reset() {
				//this.init()
			}
		},
		components: {
			addIndex
		}
	}
</script>